var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-select", {
    staticStyle: {
      width: "230px",
      "margin-left": "20px"
    },
    attrs: {
      multiple: _vm.multiple,
      placeholder: "请选择",
      "collapse-tags": "",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.someSelect(_vm.label);
      }
    },
    model: {
      value: _vm.label,
      callback: function callback($$v) {
        _vm.label = $$v;
      },
      expression: "label"
    }
  }, [_vm.all ? _c("el-checkbox", {
    on: {
      change: function change($event) {
        return _vm.selectAll();
      }
    },
    model: {
      value: _vm.checked,
      callback: function callback($$v) {
        _vm.checked = $$v;
      },
      expression: "checked"
    }
  }, [_vm._v("全选")]) : _vm._e(), _vm._l(_vm.serverList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.label,
        value: item.id
      }
    });
  })], 2)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };